var React = require('react');

function BlueTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.576904 13.9952L25.707 0.587799L24.7531 29.0548L0.576904 13.9952Z","fill":"#70FAFF","key":0}),React.createElement("path",{"d":"M25.7069 0.587799L24.753 29.0548L17.4919 24.5318L25.7069 0.587799Z","fill":"#14DAE1","key":1})]);
}

BlueTriangle.defaultProps = {"width":"26","height":"30","viewBox":"0 0 26 30","fill":"none"};

module.exports = BlueTriangle;

BlueTriangle.default = BlueTriangle;
